import { NgModule } from '@angular/core';
import { ProductCompareRoutingModule } from '@search/compare/product-compare-routing.module';
import { ProductComparePage } from '@search/compare/product-compare.page';
import { ProductComparisonComponent } from '@search/compare/comparator/product-comparison.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { SearchSharedModule } from '@search/shared/search-shared.module';
import { ProductComparisonProductAttributesComponent } from '@search/compare/components/product-comparison-product-attributes/product-comparison-product-attributes.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProductComparisonPopoverComponent } from './components/product-comparison-popover/product-comparison-popover.component';
import { SharedProductModule } from '@app/shared-product/shared-product.module';

@NgModule({
  imports: [
    ProductCompareRoutingModule,
    CommonModule,
    FormsModule,
    SharedModule,
    SearchSharedModule,
    DragDropModule,
    SharedProductModule,
  ],
  declarations: [
    ProductComparisonComponent,
    ProductComparisonPopoverComponent,
    ProductComparePage,
    ProductComparisonProductAttributesComponent,
  ],
})
export class ProductCompareModule {}
